import { USERS_USER_TYPE_VALUE_CUSTOMER } from "../../../constants/users";

/**
 * Retourne si l’utilisateur courant peut accéder à la page.
 * @param {object} param0
 * @param {import("../../../types/User").UserBase} [param0.user]
 * @param {import("../../../types/authorizations/authorization").NextIsAuthorized} param0.authorized
 * @param {number} [param0.hotelId]
 * @param {number} [param0.roomId]
 * @returns {Promise<import("../../../types/authorizations/authorization").NextIsAuthorized>}
 */
export default async function nextIsAuthorizedHotelRoom({
  user,
  authorized,
  hotelId,
  roomId,
}) {
  const _authorized = authorized;
  // Logique spécifique pour les pages avec hotelId ou roomId
  if (roomId || hotelId) {
    if (user?.user_type === USERS_USER_TYPE_VALUE_CUSTOMER) {
      const customerUser =
        /** @type {import("../../../types/Customer").Customer} */ (user);

      const hotelIds = [];
      customerUser.rooms_infos?.forEach((room) => {
        hotelIds.push(room.hotel_id);
      });

      // Si l'utilisateur n'a pas accès à l'hôtel, on bloque l'accès
      if (hotelId && !hotelIds?.includes(hotelId)) {
        _authorized.globally = false;
        return _authorized;
      }

      const roomIds = [];

      customerUser.rooms_infos?.forEach((room) => {
        roomIds.push(room.id);
      });

      // Si l'utilisateur n'a pas accès à la room, on bloque l'accès
      if (roomId && !roomIds?.includes(roomId)) {
        _authorized.globally = false;
        return _authorized;
      }
    }
  }

  return _authorized;
}
